module.exports = __webpack_public_path__ + "static/img/bg_city.46c6bf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/backgrounds/thumbnail/bg_city.png
// module id = gSdQ
// module chunks = 0